module.exports = __webpack_public_path__ + "static/media/ckad.76957cc8.png";